import React from "react";
import BlankStateV2 from "@ui/BlankStateV2";
import { Locked } from "@ui/Illustration/react";
import { useSettings } from "../../api/useSettings";
import LoadingBoundary from "@ui/LoadingBoundary";
import { Navigate, Outlet, useLocation } from "react-router";
import SidePanelLayout from "@ui/SidePanel/Layout";
import { ReportingHeader } from "./Header";

export const Reporting = () => {
  const location = useLocation();
  const settings = useSettings();

  if (!settings.FLEET_VIEW_ENABLED)
    return (
      <BlankStateV2
        title="This feature is not available"
        subtitle="Please contact your administrator for further information."
        picto={<Locked size="l" />}
      />
    );

  if (location.pathname === "/reporting") return <Navigate to="/reporting/performance" replace />;

  return (
    <>
      <ReportingHeader />
      <SidePanelLayout>
        <LoadingBoundary>
          <Outlet />
        </LoadingBoundary>
      </SidePanelLayout>
    </>
  );
};
